import { Button } from '@components/Button';
import type { ReactElement } from 'react';

export function BigCommerceCheckoutButton({
  styledButton,
  className,
  location,
}: {
  styledButton: boolean;
  className?: string;
  location?: string;
}): ReactElement {
  if (styledButton) {
    return (
      <Button
        href="/checkout"
        buttonStyle="primary"
        className={className}
        data-umami-event-location={location}
      >
        Checkout
      </Button>
    );
  }
  return (
    <a
      href="/checkout"
      className={className}
      data-umami-event="hue-link-click"
      data-umami-event-slug="/checkout"
      data-umami-event-location={location}
    >
      Checkout
    </a>
  );
}
